export { default } from './TipCard';
